import { useEffect } from 'react';
import { Provider } from 'react-redux';
import Router from './routes';
import Store from './configureStore';
import {
  quiz,
  app,
  discovery,
  profile,
  tracker,
  gamification,
  interactions,
  recycleRight,
  other
} from './redux/actions';
import './scss/index.scss';
import { retrieveInteractions } from './helpers/gamification';
// import dzData from './app/responses/dzData';
import {
  blogReducer,
  learningModulesReducer,
  misundestoodMaterialsReducer,
  recyclingFundamentalsReducer
} from './helpers/discoveryReducer';
import {
  lmQuizReducer,
  mumQuizReducer,
  rfQuizReducer
} from './helpers/quizReducer';
import WithHandler from './WithHandler';

const { store } = Store;

function App() {
  useEffect(() => {
    const { dispatch } = store;
    try {
      dispatch(app.setAccountId(window.accountId || ''));
      dispatch(app.setAppVersion(window.appVersion || '18.0.0'));
      dispatch(app.setMainColor(window.mainColor === 'undefined' ? false : window.mainColor));
      dispatch(app.setApiGWPrefix(window.apiGWPrefix || 'ca'));
      dispatch(app.setDzBrandConfigs(window.dzBrandConfigs || {}));
      if ('data' in window && window.data && Object.keys(window.data).length) {
        const {
          rf_quiz,
          misunderstood_materials_quiz,
          rf_lessons,
          misunderstood_materials,
          learning_modules,
          viewedEducationalContent = {}
        } = window.data;
        dispatch(discovery.setDiscoveryData({ ...window.data }));
        dispatch(other.setViewedEducationData(viewedEducationalContent));
        dispatch(app.setLMData(learning_modules));
        dispatch(
          quiz.setQuizData({
            rfQuiz: rf_quiz,
            mumQuiz: misunderstood_materials_quiz,
            lmQuiz: learning_modules,
            reducedFundamentals: rf_lessons,
            reducedMisunderstood: misunderstood_materials,
            reducedLearningModules: learning_modules,
          })
        );

        dispatch(profile.setProfileInfo(window.profileInfo));
      }
      if (
        'redux' in window
        && window.redux
        && Object.keys(window.redux).length
      ) {
        const {
          learning_modules, blog_articles,
          rf_lessons,
          misunderstood_materials,
          rf_quiz,
          misunderstood_materials_quiz
        } = window.data;
        const {
          discovery: discoveryData = {},
          quiz: quizData = {},
          app: appData = {},
          tracker: trackerData = {},
          gamification: gamificationData = {},
          interactions: interactionsData = {},
        } = window.redux;

        // don't cache main question data.
        dispatch(
          discovery.setWhole({
            ...discoveryData,
            learningModules: learningModulesReducer(learning_modules),
            blogPosts: blogReducer(blog_articles),
            recyclingFundamentals: recyclingFundamentalsReducer(rf_lessons),
            misundestoodMaterials: misundestoodMaterialsReducer(misunderstood_materials),
          })
        );
        dispatch(
          quiz.setWhole({
            ...quizData,
            lmQuiz: lmQuizReducer(
              learning_modules,
              learningModulesReducer(learning_modules)
            ),
            rfQuiz: rfQuizReducer(
              rf_quiz,
              recyclingFundamentalsReducer(rf_lessons)
            ),
            mumQuiz: mumQuizReducer(
              misunderstood_materials_quiz,
              misundestoodMaterialsReducer(misunderstood_materials)
            ),
            quizState: { ...quizData.quizState, lmQuiz: [] },
          })
        );
        dispatch(
          app.setWhole({
            ...appData,
            apiGWPrefix: window.apiGWPrefix,
            learningModulesRedux: learning_modules,
          })
        );
        dispatch(tracker.setWhole({ ...trackerData, tookLmQuiz: false }));
        dispatch(
          gamification.setWhole({ ...gamificationData, hasPassedLmQuiz: {} })
        );
        dispatch(interactions.setWhole({ ...interactionsData, LM: [] }));
        retrieveInteractions({ ...interactionsData, LM: [] });
      }
      if ('data' in window && window.data && Object.keys(window.data).length) {
        const {
          rc_kids,
          recycle_right,
        } = window.data;
        dispatch(recycleRight.setRecycleRightData(recycle_right));
        dispatch(app.setKidsData(rc_kids));
      }
      if ('notificationData' in window
        && window.notificationData && Object.keys(window.notificationData).length) {
        dispatch(other.setNotificationData(window.notificationData));
      }
    } catch (e) {
      console.log(e);
    }
  }, [window.redux]);

  return (
    <WithHandler>
      <Provider store={store}>
        <Router />
      </Provider>
    </WithHandler>
  );
}

export default App;
